import { Base64 } from "js-base64";
var library =  {
  time(ns) {
    var date = new Date(ns);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() ;
    return Y + M + D;
  },
  safeEncodeBase64(str) {
    if (typeof str != "string") str = JSON.stringify(str);
    str = Base64.encodeURI(str);
    // var string = str.replace(/\+/g, "^").replace(/\//g, "_").replace(/=/g, "*");
    return str;
  },
  getUrlParam(name) {
      var url = decodeURIComponent(window.location.href);
      var reg = new RegExp('(\\?|&)' + name + '=([^&?#]*)', 'i');
      var arr = url.match(reg);
      if (arr) {
        return arr[2];
      }
      return null;
    }
  }
export {
  library 
}
  